export default __webpack_public_path__ + "static/shruthi-kapoor-6ea3118749a0de29174c511f9a8f208b.png";